(function () {
    'use strict';

    var COOKIE_NAME = 'ae_cookie_consent';

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        if (!match) {
            return null;
        }

        try {
            return JSON.parse(decodeURIComponent(match[1]));
        } catch (e) {
            return null;
        }
    }

    function setCookie(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + '; expires=' + date.toUTCString() + '; path=/; SameSite=Lax';
    }

    function applyConsent(consent) {
        if (typeof window.aeApplyCookieConsent === 'function') {
            window.aeApplyCookieConsent(consent);
        }
    }

    function init() {
        var banner = document.getElementById('CookieConsent');

        if (!banner) {
            return;
        }

        var duration = parseInt(banner.getAttribute('data-duration'), 10) || 180;
        var mainView = banner.querySelector('[data-js-cookie-consent-main]');
        var categoriesView = banner.querySelector('[data-js-cookie-consent-categories]');
        var analyticsToggle = banner.querySelector('[data-js-cookie-consent-toggle="analytics_marketing"]');
        var reopenBtn = document.querySelector('[data-js-cookie-consent-reopen]');

        function showBanner(customizing) {
            banner.classList.remove('d-none');
            if (reopenBtn) {
                reopenBtn.classList.add('d-none');
            }
            setCustomizing(!!customizing);
        }

        function hideBanner() {
            banner.classList.add('d-none');
            if (reopenBtn) {
                reopenBtn.classList.remove('d-none');
            }
        }

        function setCustomizing(isCustomizing) {
            if (isCustomizing) {
                mainView.classList.add('d-none');
                categoriesView.classList.remove('d-none');
            } else {
                mainView.classList.remove('d-none');
                categoriesView.classList.add('d-none');
            }
        }

        function saveConsent(consent) {
            setCookie(COOKIE_NAME, consent, duration);
            applyConsent(consent);
            hideBanner();
        }

        banner.addEventListener('click', function (e) {
            var action = e.target.getAttribute('data-js-action');

            if (!action) {
                return;
            }

            if (action === 'accept') {
                saveConsent({ necessary: true, analytics_marketing: true });
            } else if (action === 'reject') {
                saveConsent({ necessary: true, analytics_marketing: false });
            } else if (action === 'customize') {
                var existing = getCookie(COOKIE_NAME);
                if (analyticsToggle) {
                    analyticsToggle.checked = !!(existing && existing.analytics_marketing);
                }
                setCustomizing(true);
            } else if (action === 'back') {
                setCustomizing(false);
            } else if (action === 'save') {
                saveConsent({
                    necessary: true,
                    analytics_marketing: !!(analyticsToggle && analyticsToggle.checked)
                });
            }
        });

        if (reopenBtn) {
            reopenBtn.addEventListener('click', function () {
                var existing = getCookie(COOKIE_NAME);
                if (analyticsToggle) {
                    analyticsToggle.checked = !!(existing && existing.analytics_marketing);
                }
                showBanner(true);
            });
        }

        var consent = getCookie(COOKIE_NAME);

        if (consent) {
            applyConsent(consent);
            hideBanner();
        } else {
            showBanner(false);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
